import { APP } from "@constants/app.constants";
import { uploadImageFile } from "@utils/upload.util";
import { BASE_URL } from "@constants/api.constants";

const { IS_DEFAULT, STATUS } = APP;

export const getProfileFormInputs = (initialValues) => [
  {
    groupName: "General",
    hideGroupName: true,
    type: "TEXT",
    label: "Name",
    id: "name",
    name: "name",
    value: initialValues?.name || "",
    placeholder: "Enter the Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Profile Name is required !",
      },
    ],
  },
  {
    groupName: "General",
    hideGroupName: true,
    type: "TEXT",
    label: "E-mail",
    id: "email",
    name: "email",
    value: initialValues?.email || "",
    placeholder: "Enter the e-mail",
    validations: [
      {
        type: "REQUIRED",
        message: "E-mail is required !",
      },
    ],
  },
  {
    groupName: "General",
    hideGroupName: true,
    type: "TEXT",
    label: "Mobile",
    id: "mobile",
    name: "mobile",
    value: initialValues?.mobile || "",
    placeholder: "Enter the Mobile no",
    validations: [
      {
        type: "REQUIRED",
        message: "Mobile is required !",
      },
    ],
  },
  {
    groupName: "General",
    type: "CALENDER",
    label: "Date of birth",
    id: "dob",
    name: "dob",
    value: initialValues?.dob || new Date(),
    placeholder: "Select Date",
    validations: [],
  },
  {
    groupName: "General",
    type: "FILE_UPLOAD",
    label: "Profile Picture",
    isVertical: false,
    staticHeader: true,
    id: "profile_image",
    name: "profile_image",
    value: initialValues?.profileImage,
    placeholder: "Please select the files",
    validations: [],
    handleSelfUpload: uploadImageFile,
    filePrefix: BASE_URL + "app-source/images/",
  },
];
